import { Component, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { GeoAreaSipKpi } from 'src/app/assabil-sales/models/dtos/geo-area-sip-kpi';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';


  @Component({
    selector: 'danone-sip-monitoring-widget',
    templateUrl: './danone-sip-monitoring-widget.component.html',
    styleUrls: ['./danone-sip-monitoring-widget.component.scss']
  })
  
  export class DanoneSipMonitoringWidgetComponent extends BaseWidget {

    @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;
  
    geoArea             : GeoArea;
    selectedGeoArea     : GeoArea = null
    date                : Date = new Date();
    dateTemp            : Date = new Date();
    title               : string = "Suivi DN SIP";
    period              : string = "12/2030";
    dnPeriod            : string = "12/2030";

    dnProductFamilyCode : string;
    dnProductFamilyName : string;
    subPeriodCode       : string;
    geoAreaCode         : string;
    geoAreaName         : string;
    kpi                 : string;
    periodActiveDay     : Date;

    geoAreaSipKpi  :  GeoAreaSipKpi;


    showPartnerList       : boolean = false;
    

    constructor(
      protected datepipe: DatePipe,
      protected specificDanoneService   : SpecificDanoneService,
      protected controlTablesService    : ControlTablesService,
      protected leanUtilsService        : LeanUtilsService,
      protected masterDataService       : MasterDataService,
      protected toastr                  : ToastrService,
      protected router                  : Router,
      protected location                : Location) {
        super(toastr, leanUtilsService);
        
  
    }
  
  //----------------------------------------------------------------------------------------------------------------------------------
  ngOnInit(){
    this.date.setDate(this.date.getDate() - 1);
    super.ngOnInit();
    this.controlTablesService.personGeoAreaGet().then(result => {
      this.geoArea = result;
    })
  }
  //----------------------------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------------------------------------------------------------------
  loadData() {
    if ( (! this.selectedGeoArea) ||   (! this.date) ){
      this.toastr.error("Prière de préciser les paramètres de la recherhe");
      return;
    }
    
    this.specificDanoneService.geoAreaSipKpisGet(this.selectedGeoArea.geoAreaCode, this.date).then(geoAreaSipKpi => {
        this.geoAreaSipKpi = geoAreaSipKpi;
    })
    this.title = "Suivi DN SIP - Date : " + this.datepipe.transform(this.date, 'dd/MM/yyyy') + " | " + this.selectedGeoArea.name;
    this.period = this.datepipe.transform(this.date, 'MM/yyyy');
  }
 //----------------------------------------------------------------------------------------------------------------------------------

 //----------------------------------------------------------------------------------------------------------------------------------

click(event : any){
  this.dnProductFamilyCode = event.dnProductFamilyCode;
  this.dnProductFamilyName = event.dnProductFamilyName;
  this.subPeriodCode   = event.subPeriodCode;
  this.geoAreaCode     = event.geoArea.geoAreaCode;
  this.geoAreaName     = event.geoArea.name;
  this.kpi             = event.kpi;
  this.periodActiveDay = this.date;
  this.dnPeriod        = this.period;
  this.showPartnerList = true;
}
//----------------------------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------
  selectGeoAreaAndGo(geoArea : GeoArea){ 
    this.selectGeoArea(geoArea);
    this.leanDataForm.hideFilter();
    this.loadData();
  }
  selectGeoArea(geoArea : GeoArea){
    if (this.selectedGeoArea != null) this.selectedGeoArea.selected = false;
    this.selectedGeoArea = geoArea;
    this.selectedGeoArea.selected=true;
  }
//----------------------------------------------------------------------


//--------------------------------------------------------------------------------------
returnBack(){
  this.location.back();
}
//--------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------
  setEntity(data: BaseEntity) {
    throw new Error("Method not implemented.");
  }
  getEntity(): BaseEntity {
    throw new Error("Method not implemented.");
  }
  saveRow(): Promise<BaseEntity> {
    throw new Error("Method not implemented.");
  }
  //--------------------------------------------------------------------------------------
    
  }
  
  